import styled, { css } from 'styled-components/macro';
import { ADAPTIVE, BREAKPOINT } from '@yme/tokens/screen';
/**
 * @deprecated
 *
 * note: Need use 'Grid' (Container/Row/Col) from '../atoms/grid'; instead of '../atoms/grid-old';
 *
 * @TODO After replacing all "grid-old" with "grid", this ad should be removed.
 */
export const Container = styled.div `
  margin: 0 auto;
  box-sizing: border-box;
  position: relative;
  max-width: ${BREAKPOINT.xlg}px;
  ${({ width }) => width && `width: ${width};`}

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}

  padding: ${({ xxlPadding = '0 48px' }) => xxlPadding};

  ${ADAPTIVE.maxWidth.tablet} {
    padding: ${({ lgPadding = '0 24px' }) => lgPadding};
  }

  ${ADAPTIVE.maxWidth.mobile} {
    padding: ${({ smPadding = '0 16px' }) => smPadding};
  }
`;
/**
 * @deprecated
 *
 * note: Need use 'Grid' (Container/Row/Col) from '../atoms/grid'; instead of '../atoms/grid-old';
 *
 * @TODO After replacing all "grid-old" with "grid", this ad should be removed.
 */
export const Row = styled.div `
  display: flex;
  flex-wrap: wrap;

  margin: ${({ xxlMargin = '0px -12px' }) => xxlMargin};
  padding: ${({ xxlPadding = '0' }) => xxlPadding};

  ${ADAPTIVE.maxWidth.tablet} {
    margin: ${({ lgMargin = '0px -12px' }) => lgMargin};
    padding: ${({ lgPadding = '0' }) => lgPadding};
  }

  ${ADAPTIVE.maxWidth.mobile} {
    margin: ${({ smMargin = '0px -12px' }) => smMargin};
    padding: ${({ smPadding = '0' }) => smPadding};
  }
`;
/**
 * @deprecated
 *
 * note: Need investigate this feature;
 */
/**
 * @deprecated
 *
 * note: Need use 'Grid' (Container/Row/Col) from '../atoms/grid'; instead of '../atoms/grid-old';
 *
 * @TODO After replacing all "grid-old" with "grid", this ad should be removed.
 */
export const Col = styled.div `
  box-sizing: border-box;

  padding: ${({ xxlPadding = '0' }) => xxlPadding};

  ${({ xxl }) => xxl &&
    css `
      width: calc(${100 / (12 / xxl)}% - 24px);
      margin: 0px 12px;
    `}

  ${ADAPTIVE.maxWidth.tablet} {
    ${({ lg, lgWidthCorr }) => lg && `width: calc(${100 / (12 / lg)}% - ${lgWidthCorr || '24px'});`};

    padding: ${({ lgPadding = '0' }) => lgPadding};
    margin: ${({ lgMargin = '0px 12px' }) => lgMargin};

    ${({ lgOrder }) => lgOrder && `order: ${lgOrder};`}
  }

  ${ADAPTIVE.maxWidth.mobile} {
    ${({ sm }) => sm && `width: calc(${100 / (12 / sm)}% - 12px);`};
    ${({ smFullWidth }) => smFullWidth && 'width: 100%;'};

    padding: ${({ smPadding = '0' }) => smPadding};
    margin: ${({ smMargin = '0px 12px' }) => smMargin};

    ${({ smOrder }) => smOrder && `order: ${smOrder};`};
  }
`;
